import OfferService from '../../../../core/services/offer.service'
import { saveOfferDocumentId } from '../../../../core/services/storage.service'
import { LifecyclePresenter } from '../../../_components/ConnectComponent'
import { AdobeEventManager } from '../../../_utils/adobeAnalytics'
import { dataLayer } from '../../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { mountDownablePDF } from '../../../_utils/pdfs/pdf'
import { OfferTableRaw, View } from './OfferTable.view'

export class OfferTablePresenter implements LifecyclePresenter<View> {
  private view!: OfferTableRaw

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    try {
      const offerList = await OfferService.getOffersList()

      this.view.setInitialValues(
        offerList.notExpiredOffers,
        offerList.pagination,
      )
      dataLayer.page.category.applicationStep = 'portal'
      dataLayer.page.category.pageCategory = 'Portal'
    } catch (error) {
      console.log(error)
    }
  }

  getOffers = async (page?: number, pageSize?: number) => {
    const offerList = await OfferService.getOffersList(page, pageSize)
    return offerList
  }

  onContract = async (offerId: string) => {
    await this.saveOffer(offerId)
    this.view.props.history.push('/contract/duration')
  }

  onDiscardOffer = async (offerId: string) => {
    await OfferService.discardOffer(offerId)
    this.view.getOffers()
  }

  onDownloadOfferPDF = async (offerId: string, offerNumber: number) => {
    this.view.showLoading()

    try {
      let pdf = await OfferService.getOfferPDF(offerId)
      mountDownablePDF(pdf, offerNumber, false)

      AdobeEventManager.emit('portal_download_offer_pdf', 'file_downloads')

      this.view.hideLoading()
    } catch (error) {
      console.log(error)

      this.view.hideLoading()
      alert('It is NOT available to get PDF for your query')
    }
  }

  onSendOfferToCustomer = async (offerId: string) => {
    await OfferService.sendOfferByEmail(offerId)
    AdobeEventManager.emit(
      'agent/broker_send_offer_by_email_to_customer',
      'direct_contact_to_agent',
    )

    this.view.showModal()
  }

  goToViewOffer = async (offerId: string) => {
    await this.saveOffer(offerId)
    this.view.props.history.push('/summary')
  }

  saveOffer = async (offerId: string) => {
    const offer = await OfferService.getOfferDocument(offerId)
    saveOfferDocumentId(offer.id.toString())
  }
}
